import request from '@/utils/request'

/**
 * 获取报表自定义组件关系列表
 * @param {Object} params 查询参数
 * @returns {Promise} 包含报表自定义组件关系列表的Promise对象
 */
export function listReportCustomComponentRel(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomComponentRel.listReportCustomComponentRel',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 保存报表自定义组件关系
 * @param {Object} data 报表自定义组件关系数据
 * @returns {Promise} 包含保存结果的Promise对象
 */
export function saveReportCustomComponentRel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomComponentRel.saveReportCustomComponentRel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除报表自定义组件关系
 * @param {Object} data 包含要删除的报表自定义组件关系ID的数据
 * @returns {Promise} 包含删除结果的Promise对象
 */
export function deleteReportCustomComponentRel(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/reportCustomComponentRel.deleteReportCustomComponentRel',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}